"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RootDataStore = void 0;
var UserDataStore_1 = require("./User/UserDataStore");
var PermissionsDataStore_1 = require("./Permissions/PermissionsDataStore");
var PermissionsService_1 = require("./Permissions/PermissionsService");
var AccountDataStore_1 = require("./Account/AccountDataStore");
var ProjectTagDataStore_1 = __importDefault(require("./ProjectTag/ProjectTagDataStore"));
var DashboardFoldersDataStore_1 = require("Dashboard/Stores/DashboardFoldersDataStore");
var FoldersApiService_1 = require("Dashboard/FoldersApiService/FoldersApiService");
var PageResourceApiService_1 = require("Dashboard/ProjectList/PageResourceApiService");
var AccountApiService_1 = __importDefault(require("./Account/AccountApiService"));
var SavedBlockResourceApiService_1 = require("Dashboard/DashboardBlockLibrary/SavedBlockResourceApiService");
var Types_1 = require("@CommonFrontendBackend/Folders/Types");
var RootDataStore = (function () {
    function RootDataStore(usingFeature, teamsService, apiBaseUrl, user, userList, projectTags, telemetry, accountService, imageResourceApiService, $rootScope, $timeout) {
        var pageResourceApiService = new PageResourceApiService_1.PageResourceApiService(apiBaseUrl);
        var savedBlockResourceApiService = new SavedBlockResourceApiService_1.SavedBlockResourceApiService(apiBaseUrl);
        var foldersApiService = new FoldersApiService_1.FoldersApiService(apiBaseUrl);
        var accountApiService = new AccountApiService_1.default(apiBaseUrl, telemetry, user.account._id);
        this.accountDataStore = new AccountDataStore_1.AccountDataStore(apiBaseUrl, user, userList, teamsService, accountApiService, accountService, { $scope: $rootScope, $timeout: $timeout });
        this._projectTagDataStore = new ProjectTagDataStore_1.default(projectTags);
        this._userDataStore = new UserDataStore_1.UserDataStore(user, apiBaseUrl, telemetry, { $scope: $rootScope, $timeout: $timeout });
        this._pageFoldersDataStore = new DashboardFoldersDataStore_1.DashboardFoldersDataStore(this._userDataStore.id, foldersApiService, pageResourceApiService, telemetry, Types_1.CollectionType.Page);
        this._blockFoldersDataStore = new DashboardFoldersDataStore_1.DashboardFoldersDataStore(this._userDataStore.id, foldersApiService, savedBlockResourceApiService, telemetry, Types_1.CollectionType.Block);
        this._imageFoldersDataStore = new DashboardFoldersDataStore_1.DashboardFoldersDataStore(this._userDataStore.id, foldersApiService, imageResourceApiService, telemetry, Types_1.CollectionType.UploadedImage);
        var permissionsService = new PermissionsService_1.PermissionsService(apiBaseUrl);
        this.permissionsStore = new PermissionsDataStore_1.PermissionsDataStore(permissionsService, user, this.accountDataStore.getUsersDataStore(), this.accountDataStore);
    }
    RootDataStore.prototype.getPermissionsDataStore = function () {
        return this.permissionsStore;
    };
    RootDataStore.prototype.getAccountDataStore = function () {
        return this.accountDataStore;
    };
    RootDataStore.prototype.getAccountIntegrationsDataStore = function () {
        return this.accountDataStore.getIntegrationsDataStore();
    };
    Object.defineProperty(RootDataStore.prototype, "projectTagDataStore", {
        get: function () {
            return this._projectTagDataStore;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RootDataStore.prototype, "userDataStore", {
        get: function () {
            return this._userDataStore;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RootDataStore.prototype, "pageFoldersDataStore", {
        get: function () {
            return this._pageFoldersDataStore;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RootDataStore.prototype, "blockFoldersDataStore", {
        get: function () {
            return this._blockFoldersDataStore;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RootDataStore.prototype, "imageFoldersDataStore", {
        get: function () {
            return this._imageFoldersDataStore;
        },
        enumerable: false,
        configurable: true
    });
    return RootDataStore;
}());
exports.RootDataStore = RootDataStore;
